const MetaMask = function (props) {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.45044 21.4201L10.8308 22.2949V21.151L11.1068 20.8818H13.0384V22.2276V23.1696H10.9688L8.41624 22.093L7.45044 21.4201Z"
          fill="#CDBDB2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4883 21.4201L15.177 22.2949V21.151L14.901 20.8818H12.9694V22.2276V23.1696H15.039L17.5914 22.093L18.4883 21.4201Z"
          fill="#CDBDB2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1068 18.9302L10.8308 21.1507L11.1757 20.8815H14.7629L15.1769 21.1507L14.9009 18.9302L14.349 18.5938L11.5896 18.6611L11.1068 18.9302Z"
          fill="#393939"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.24414 3.9248L10.8998 7.69292L11.6587 18.6609H14.3491L15.1769 7.69292L16.6946 3.9248H9.24414Z"
          fill="#F89C35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.0007 12.2013L0.0690918 17.6515L4.8981 17.3824H8.0024V15.0273L7.86443 10.1826L7.17457 10.7209L2.0007 12.2013Z"
          fill="#F89D35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.65698 12.8076L11.3138 12.9422L10.693 15.7683L8.0025 15.0954L5.65698 12.8076Z"
          fill="#D87C30"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.65698 12.874L8.0025 15.0272V17.1804L5.65698 12.874Z"
          fill="#EA8D3A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00244 15.0947L10.7619 15.7676L11.6588 18.661L11.0378 18.9974L8.00244 17.2479V15.0947Z"
          fill="#F89D35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00233 17.248L7.45044 21.4199L11.1067 18.9303L8.00233 17.248Z"
          fill="#EB8F35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3136 12.9414L11.6586 18.6609L10.6238 15.7339L11.3136 12.9414Z"
          fill="#EA8E3A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.8291 17.3154L8.00245 17.248L7.45056 21.4199L4.8291 17.3154Z"
          fill="#D87C30"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.58678 23.2368L7.45051 21.4199L4.82905 17.3154L0.0690918 17.6518L1.58678 23.2368Z"
          fill="#EB8F35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8999 7.69336L7.93358 10.1157L5.65698 12.8072L11.3138 13.0092L10.8999 7.69336Z"
          fill="#E8821E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.45044 21.4202L11.1067 18.9307L10.8308 21.0839V22.295L8.34732 21.824L7.45044 21.4202Z"
          fill="#DFCEC3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4883 21.4202L14.901 18.9307L15.177 21.0839V22.295L17.6604 21.824L18.4883 21.4202Z"
          fill="#DFCEC3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.79602 14.1533L10.5549 15.701L7.86442 15.0281L9.79602 14.1533Z"
          fill="#393939"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.51782 0.762695L10.8999 7.69328L9.31328 3.92516L1.51782 0.762695Z"
          fill="#E88F35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.51762 0.762695L0.275879 4.46352L0.965737 8.50079L0.482836 8.76994L1.17269 9.37553L0.620808 9.84655L1.37965 10.5194L0.896751 10.9232L2.00052 12.2689L7.17446 10.7213C9.70394 8.74751 10.9457 7.7382 10.8997 7.69334C10.8537 7.64848 7.72635 5.33826 1.51762 0.762695Z"
          fill="#8E5A30"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.938 12.2013L25.8696 17.6515L21.0406 17.3824H17.9363V15.0273L18.0743 10.1826L18.7642 10.7209L23.938 12.2013Z"
          fill="#F89D35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.2817 12.8076L14.6249 12.9422L15.2457 15.7683L17.9362 15.0954L20.2817 12.8076Z"
          fill="#D87C30"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.2817 12.874L17.9362 15.0272V17.1804L20.2817 12.874Z"
          fill="#EA8D3A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9363 15.0947L15.1768 15.7676L14.28 18.661L14.9009 18.9974L17.9363 17.2479V15.0947Z"
          fill="#F89D35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9364 17.248L18.4883 21.4199L14.901 18.9975L17.9364 17.248Z"
          fill="#EB8F35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6251 12.9414L14.2801 18.6609L15.3149 15.7339L14.6251 12.9414Z"
          fill="#EA8E3A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.1096 17.3154L17.9363 17.248L18.4882 21.4199L21.1096 17.3154Z"
          fill="#D87C30"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.3519 23.2368L18.4882 21.4199L21.1097 17.3154L25.8696 17.6518L24.3519 23.2368Z"
          fill="#EB8F35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0388 7.69336L18.0051 10.1157L20.2817 12.8072L14.6249 13.0092L15.0388 7.69336Z"
          fill="#E8821E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.1427 14.1533L15.3838 15.701L18.0743 15.0281L16.1427 14.1533Z"
          fill="#393939"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.4209 0.762695L15.0388 7.69328L16.6254 3.92516L24.4209 0.762695Z"
          fill="#E88F35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.4211 0.762695L25.6628 4.46352L24.973 8.50079L25.4559 8.76994L24.766 9.37553L25.3179 9.84655L24.5591 10.5194L25.042 10.9232L23.9382 12.2689L18.7643 10.7213C16.2348 8.74751 14.993 7.7382 15.039 7.69334C15.085 7.64848 18.2124 5.33826 24.4211 0.762695Z"
          fill="#8E5A30"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="26"
            height="22.6087"
            fill="white"
            transform="translate(0 0.695312)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MetaMask;
